module.exports = __webpack_public_path__ + "static/media/turkey@3x.fe0c2c59.jpg";